import { render } from "./ConfigTableRow.vue?vue&type=template&id=5fb6032d&ts=true"
import script from "./ConfigTableRow.vue?vue&type=script&lang=ts"
export * from "./ConfigTableRow.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__